import { render } from "./PluginSelect.vue?vue&type=template&id=99887c84"
import script from "./PluginSelect.vue?vue&type=script&lang=js"
export * from "./PluginSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\onix.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__